<template>
  <van-popup v-model="show" position="bottom" @close="bindClose">
    <div class="content">
      <div class="title">{{ title }}</div>
      <div class="scroll">
        <div class="list">
          <div
            class="item"
            :class="{ 'item-active': curIndex == index }"
            v-for="(item, index) in columns"
            :key="index"
            @click="bindClick(index)"
          >
            <span class="text">{{ item[valueKey] }}</span>
            <span
              class="icon iconfont icon-gou"
              v-if="curIndex == index"
            ></span>
          </div>
        </div>
      </div>
      <div class="btn-content">
        <div class="btn-item" @click="bindCancel">取消</div>
        <div class="btn-item btn-active" @click="bindConfirm">确认</div>
      </div>
    </div>
  </van-popup>
</template>
<script>
export default {
  props: {
    value: {
      type: Boolean,
      default: false
    },
    title: {
      type: String,
      default: ''
    },
    columns: {
      type: Array,
      default: () => []
    },
    valueKey: {
      type: String,
      default: 'value'
    },
    defaultIndex: {
      type: Number,
      default: 0
    }
  },
  watch: {
    value: {
      handler(val) {
        this.show = val
      },
      immediate: true
    },
    defaultIndex: {
      handler(val) {
        this.curIndex = val
      },
      immediate: true
    }
  },
  data() {
    return {
      show: false,
      curIndex: 0
    }
  },
  methods: {
    bindClose() {
      this.$emit('cancel')
    },
    bindCancel() {
      this.$emit('input', false)
      this.$emit('cancel')
    },
    bindConfirm() {
      this.$emit('input', false)
      this.$emit('confirm', this.columns[this.curIndex])
    },
    bindClick(index) {
      this.curIndex = index
    }
  }
}
</script>
<style lang="scss" scoped>
.content {
  padding: 11px 20px 34px;
  background: #f9f9f9;

  .title {
    text-align: center;
    font-size: 18px;
    font-family: PingFangSC-Semibold, PingFang SC;
    font-weight: 600;
    color: rgba(0, 0, 0, 0.8);
    line-height: 24px;
    margin-bottom: 15px;
  }

  .scroll {
    max-height: 214px;
    overflow-y: scroll;
    margin-bottom: 24px;

    .list {
      .item {
        padding: 0px 20px;
        height: 46px;
        background: #ffffff;
        border-radius: 8px;
        display: flex;
        align-items: center;
        margin-bottom: 10px;
        .text {
          flex: 1;
          flex-shrink: 0;
          overflow: hidden;
          text-overflow: ellipsis;
          white-space: nowrap;
          font-size: 16px;
          font-family: PingFangSC-Medium, PingFang SC;
          font-weight: 600;
          color: rgba(0, 0, 0, 0.8);
          line-height: 22px;
          margin-right: 10px;
        }

        .icon {
          color: #6236ff;
        }
      }

      .item:last-child {
        margin-bottom: 0px;
      }

      .item-active {
        .text {
          color: #6236ff;
        }
      }
    }
  }

  .btn-content {
    display: flex;
    align-items: center;
    justify-content: space-between;
    .btn-item {
      width: 159px;
      height: 42px;
      line-height: 42px;
      box-sizing: border-box;
      background: #ffffff;
      border-radius: 6px;
      border: 1px solid #f1f1f1;
      font-size: 16px;
      font-family: PingFangSC-Semibold, PingFang SC;
      font-weight: 600;
      color: rgba(0, 0, 0, 0.8);
      text-align: center;
    }
    .btn-active {
      background: #6236ff;
      border: 1px solid #6236ff;
      color: #fff;
    }
  }
}
</style>
